module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-46.a7b6227b.png";